import React from 'react';
import cls from 'classnames';

import type { TPAComponentProps } from '@wix/wix-ui-tpa/dist/cssVars/types/types';

import classes from './ListItemIcon.scss';

export interface IListItemIconProps extends TPAComponentProps {
  children?: React.ReactNode;
}

export function ListItemIcon(props: IListItemIconProps) {
  const { children, className } = props;

  if (!children) {
    return null;
  }

  return (
    <div
      data-hook={props['data-hook']}
      className={cls(classes.root, className)}
    >
      {children}
    </div>
  );
}

ListItemIcon.displayName = 'wui/ListItemIcon';
